import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const dummyReferences = [
  {
    id: 1,
    name: "Jan Novák",
    role: "Servisní technik",
    text: "Velmi rychlá komunikace a individuální přístup. Doporučuji!",
  },
  {
    id: 2,
    name: "Petra Svobodová",
    role: "Marketingová manažerka",
    text: "Vždy mi nabídl více možností a společně jsme vybrali nejvhodnější nabídku pro mě. ",
  },
  {
    id: 3,
    name: "Martin Dvořák",
    role: "Lékař",
    text: "Martin mi pomohl nastavit rozumné finanční cíle a reálnou cestu, jak se k nim dostat.",
  },
  {
    id: 4,
    name: "Lucie Bartošová",
    role: "Učitelka",
    text: " Pomohl mi vyřešit hypotéku rychleji, než jsem čekala a za výborných podmínek.",
  },
];

const PrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="top-1/2 left-0 z-20 absolute px-4 text-dark text-5xl -translate-y-1/2 cursor-pointer select-none transform"
  >
    ‹
  </div>
);

const NextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="top-1/2 right-0 z-20 absolute px-4 text-dark text-5xl -translate-y-1/2 cursor-pointer select-none transform"
  >
    ›
  </div>
);

export default function References() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section id="reference" className="bg-primary py-20 overflow-hidden scroll-mt-16">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl text-center">
        <h2 className="mb-4 font-extrabold text-light text-3xl sm:text-4xl">
          Co o mně říkají klienti
        </h2>
        <p className="mb-12 text-dark text-base sm:text-lg leading-relaxed">
          Zkušenosti lidí, se kterými jsem měl možnost spolupracovat.
        </p>

        <div className="relative">
          <Slider {...settings}>
            {dummyReferences.map(({ id, name, role, text }) => (
              <div key={id} className="px-3">
                <div className="flex flex-col justify-between bg-light shadow-md md:hover:shadow-lg p-8 rounded-2xl h-full text-dark text-left transition">
                  <p className="mb-6 italic leading-relaxed">“{text}”</p>
                  <div className="mt-auto">
                    <p className="font-semibold text-lg">{name}</p>
                    <p className="text-primary text-sm">{role}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
